import React, { useState} from 'react';
import PersistentDrawerLeft from '../../components/seller/Sidebar';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import LoadingScreen from '../../components/LoadingScreen';
import Alert from '../../components/Alert';
import { useNavigate, useParams } from 'react-router';
import { useCookies } from 'react-cookie';

export default function SellerUpdateProduk() {
  const UploadButtons =
    <div className=" ms-auto me-auto d-block" style={{ width: 182, }}>
      <Stack direction="row" alignItems="center" spacing={2} sx={{ height: 55, display: "block" }}>
        <Button variant="contained" component="label" sx={{ fontSize: "12px" }}>
          pilih gambar
          <img alt="" src="/img/camera.png" className=" ms-2" style={{ width: "30px" }} onChange={(e) => {
            setImage(e.target.files[0]);
          }} />
          <input hidden accept="image/*" multiple type="file" onChange={(e) => {
            setImage(e.target.files[0])
            setUrlImg(URL.createObjectURL(e.target.files[0]))
          }} />
        </Button>
      </Stack>
    </div>

  const [cookies, setCookie] = useCookies(['accessToken']);
  const [isLoading, setIsLoading] = useState(false);
  const [alertActive, setAlertActive] = useState(true);
  const [alert, setAlert] = useState({});
  const { id } = useParams();

  const navigate = useNavigate();
  const [productData, setProductData] = React.useState({});
  const [urlImg, setUrlImg] = React.useState('');
  const [product, setProduct] = useState('');
  const [price, setPrice] = useState('');
  const [category, setCategory] = useState('');
  const [stock, setStock] = useState('');
  const [description, setDescription] = useState('');
  const [image, setImage] = useState(' ');
  const [user, setUser] = useState({})

  const activateAlert = () => {
    setAlertActive(true);
    setTimeout(() => {
      setAlertActive(false);
    }, 3000);
  };

  React.useEffect(() => {
    const validateAccessToken = async () => {
      setIsLoading(true);
      try {
        const url = 'https://w-shop-backend.up.railway.app/api/products/' + id;
        const rawResponse = await fetch(url, {
          method: 'GET',
          headers: {
            'Content-type': 'application/json',
            'Authorization': 'Bearer ' + cookies.accessToken,
          },
        })
        const response = await rawResponse.json();
        if (response.status !== 'success') {
          throw new Error();
        } else {
          setProductData(response.data);
          if (urlImg === '') {
            setUrlImg(response.data.imgUrl)
          }
        }
        setIsLoading(false);
      } catch (error) {
        setCookie('accessToken', '', { path: '/' });
        navigate('/')
      }
    }
    validateAccessToken();
  }, [cookies.accessToken, id, navigate, setCookie, urlImg])

  const uploadImage = async (image) => {
    setIsLoading(true)
    const url = 'https://w-shop-backend.up.railway.app/api/images?type=PRODUCT_IMG';
    const form = new FormData();
    form.append('image', image);
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Authorization': 'Bearer ' + cookies.accessToken,
      },
      body: form,
    })
    const body = await response.json();
    setUrlImg(body.data.imageUrl)
    setIsLoading(false)
    return body.data;
  }

  const handleAddProduct = async () => {
    try {
      setIsLoading(true);
      let imageData = {}
      if (image !== ' ') {
        imageData = await uploadImage(image);
      } else {
        imageData = { imageUrl: productData.imgUrl, imageId: productData.imgId }
      }
      let productt = (product !== '' ? product : productData.product)
      let pricee = (price !== '' ? price : productData.price)
      let categoryy = (category !== '' ? category : productData.category)
      let stockk = (stock !== '' ? stock : productData.stock)
      let descriptionn = (description !== '' ? description : productData.description)
      const data = {
        imgId: imageData.imageId,
        imgUrl: imageData.imageUrl,
        product: productt,
        price: pricee,
        category: categoryy,
        stock: stockk,
        status: true,
        description: descriptionn,
      };
      const url = `https://w-shop-backend.up.railway.app/api/products/` + productData.id;
      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-type': 'application/json',
          'Authorization': 'Bearer ' + cookies.accessToken,
        },
        body: JSON.stringify(data),
      });
      const body = await response.json();
      if (body.status !== 'success') {
        throw new Error(body.message,);
      } else {
        const urlImg = `https://w-shop-backend.up.railway.app/api/images?type=PRODUCT_IMG&imageId=${productData.imgId}`;
        console.log();
        const form = new FormData();
        form.append('image', image);
        await fetch(urlImg, {
          method: 'DELETE',
          headers: {
            'Authorization': 'Bearer ' + cookies.accessToken,
          },
        })
        const event = {
          type: 'alert',
          alert: {
            type: 'success',
            message: 'Produk berhasil ditambahkan',
          }
        };
        setCookie('event', event, { path: '/' });
        setAlert(event.alert)
        activateAlert()
        setIsLoading(false)
        setTimeout(() => { navigate('/sellerProduct') }, 100);
      }
    } catch (error) {
      setIsLoading(false);
      setAlert({
        type: 'danger',
        message: 'Error: ' + error.message,
      })
      activateAlert();
    }
  }

  let updateProduct = (
    <div>
      <Alert active={alertActive} type={alert.type} message={alert.message} />
      <LoadingScreen active={isLoading} />
      <div className="toko m-5 ms-auto me-auto p-5">
        <h1 className="pToko">Tambah Produk</h1>
        <hr />

        <div className="row">
          <div className="col-12 col-md-7 pe-4">
            <div className="iTokoR mb-4">
              <h5 className="">Produk</h5>
              <input type="text" className="form-control" defaultValue={productData.product} onChange={(e) => {
                setProduct(e.target.value);
              }} />
            </div>
            <div className="iTokoR mb-4">
              <h5 className="">Harga</h5>
              <input type="text" className="form-control" defaultValue={productData.price} onChange={(e) => {
                setPrice(e.target.value);
              }} />
            </div>
            <div className="iTokoR mb-4">
              <h5 className="">Stok</h5>
              <input type="number" className="form-control" defaultValue={productData.stock} onChange={(e) => {
                setStock(e.target.value);
              }} />
            </div>
            <div className="iTokoR mb-4">
              <h5 className="">Kategori</h5>
              <input type="text" className="form-control" defaultValue={productData.category} onChange={(e) => {
                setCategory(e.target.value);
              }} />
            </div>
            <div className=" form-floating textA mb-5">
              <h5 className="">Deskripsi </h5>
              <textarea className="form-control" style={{ height: "270px" }} defaultValue={productData.description} onChange={(e) => {
                setDescription(e.target.value);
              }} ></textarea>
            </div>

          </div>
          <div className="col-12 col-md-5 border-start text-center">
            <div className="iTokoR my-5">
              <img alt="" src={urlImg} style={{ borderRadius: "100%", width: "300px", height: "300px" }} className="ms-auto me-auto d-block mt-5 mb-4" />
              {UploadButtons}
              <label className='desga d-block mt-3'>Ukuran gambar : maks 1 mb</label>
              <label className='desga d-block'>Format gambar : JPG, PNG</label>
              <button className="btn btn-outline-primary bToko mt-5 " onClick={() => { handleAddProduct() }}>Simpan</button>
            </div>
          </div>

        </div>
      </div >
    </div>
  )

  return (
    <div>
      <PersistentDrawerLeft userData={setUser} components={updateProduct} titleAppBar={"Ubah Produk"} />
    </div>
  );
}
